import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import { TransactionOutlined, DollarCircleOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

function MenuChargeIndict({ onClick }) {
  const navigate = useNavigate();
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = localStorage.getItem("USER_ID");

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };

  const menuGroups = [
    {
      groupTitle: "เงินทดรองจ่าย(เก่า)",
      show:
        ROLE_ID === "1" ||
        ROLE_ID === "14" ||
        ROLE_ID === "12" ||
        userId === "4",
      items: [
        {
          icon: <DollarCircleOutlined />,
          label: "เงินทดรองจ่าย > อนุมัติเบิก(เก่า)",
          path: "/finance/charge-indict/advane-pay",
          show: ROLE_ID === "1" || ROLE_ID === "14",
        },
        {
          icon: <TransactionOutlined />,
          label: "เงินทดรองจ่าย > อนุมัติเคลียร์(เก่า)",
          path: "/finance/charge-indict/clear-advane-pay",
          show:
            ROLE_ID === "1" ||
            ROLE_ID === "14" ||
            ROLE_ID === "12" ||
            userId === "4",
        },
      ],
    },
  ];

  return (
    <div className="dashboard-wrapper">
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div key={gIndex}>
              <Divider orientation="left">
                <Title level={4}>{group.groupTitle}</Title>
              </Divider>
              <Row gutter={[24, 24]}>
                {group.items.map(
                  (item, index) =>
                    item.show && (
                      <Col xs={12} sm={8} md={6} lg={4} key={index}>
                        <div
                          className="menu-card"
                          onClick={() => handleMenuClick(item)}
                        >
                          <div className="icon-wrapper">{item.icon}</div>
                          <Text className="menu-text-gold">
                            {
                              item.label.includes(">")
                                ? item.label.split(">")[1] // ถ้ามี '>' ให้เอาตัวหลังสุดมาโชว์
                                : item.label // ถ้าไม่มีให้โชว์ปกติ
                            }
                          </Text>
                        </div>
                      </Col>
                    ),
                )}
              </Row>
            </div>
          ),
      )}
    </div>
  );
}

export default MenuChargeIndict;
